/**
 * @file CurrencyCode.ts
 * @description Currency related functions and types
 * @module Currency
 */
import * as t from 'io-ts';
import { pipe } from 'fp-ts/function';
import invert from 'lodash-es/invert';
/**
 * ISO 4217 Currency codes
 */
export var CurrencyCodes;
(function (CurrencyCodes) {
    CurrencyCodes["UNITED_ARAB_EMIRATES_DIRHAM"] = "AED";
    CurrencyCodes["ALBANIAN_LEK"] = "ALL";
    CurrencyCodes["AFGHAN_AFGHANI"] = "AFN";
    CurrencyCodes["ARMENIAN_DRAM"] = "AMD";
    CurrencyCodes["NETHERLANDS_ANTILLEAN_GUILDER"] = "ANG";
    CurrencyCodes["ANGOLAN_KWANZA"] = "AOA";
    CurrencyCodes["ARGENTINE_PESO"] = "ARS";
    CurrencyCodes["AUSTRALIAN_DOLLAR"] = "AUD";
    CurrencyCodes["ARUBAN_FLORIN"] = "AWG";
    CurrencyCodes["AZERBAIJANI_MANAT"] = "AZN";
    CurrencyCodes["BOSNIA_HERZEGOVINA_CONVERTIBLE_MARK"] = "BAM";
    CurrencyCodes["BARBADIAN_DOLLAR"] = "BBD";
    CurrencyCodes["BANGLADESHI_TAKA"] = "BDT";
    CurrencyCodes["BULGARIAN_LEV"] = "BGN";
    CurrencyCodes["BAHRAINI_DINAR"] = "BHD";
    CurrencyCodes["BURUNDIAN_FRANC"] = "BIF";
    CurrencyCodes["BERMUDAN_DOLLAR"] = "BMD";
    CurrencyCodes["BRUNEI_DOLLAR"] = "BND";
    CurrencyCodes["BOLIVIAN_BOLIVIANO"] = "BOB";
    CurrencyCodes["BRAZILIAN_REAL"] = "BRL";
    CurrencyCodes["BAHAMIAN_DOLLAR"] = "BSD";
    CurrencyCodes["BITCOIN"] = "BTC";
    CurrencyCodes["BHUTANESE_NGULTRUM"] = "BTN";
    CurrencyCodes["BOTSWANAN_PULA"] = "BWP";
    CurrencyCodes["BELARUSIAN_RUBLE"] = "BYN";
    CurrencyCodes["BELIZE_DOLLAR"] = "BZD";
    CurrencyCodes["CANADIAN_DOLLAR"] = "CAD";
    CurrencyCodes["CONGOLESE_FRANC"] = "CDF";
    CurrencyCodes["SWISS_FRANC"] = "CHF";
    CurrencyCodes["CHILEAN_UNIT_OF_ACCOUNT_UF"] = "CLF";
    CurrencyCodes["CHILEAN_PESO"] = "CLP";
    CurrencyCodes["CHINESE_YUAN"] = "CNY";
    CurrencyCodes["COLOMBIAN_PESO"] = "COP";
    CurrencyCodes["COSTA_RICAN_COLON"] = "CRC";
    CurrencyCodes["CUBAN_CONVERTIBLE_PESO"] = "CUC";
    CurrencyCodes["CUBAN_PESO"] = "CUP";
    CurrencyCodes["CAPE_VERDEAN_ESCUDO"] = "CVE";
    CurrencyCodes["CZECH_REPUBLIC_KORUNA"] = "CZK";
    CurrencyCodes["DJIBOUTIAN_FRANC"] = "DJF";
    CurrencyCodes["DANISH_KRONE"] = "DKK";
    CurrencyCodes["DOMINICAN_PESO"] = "DOP";
    CurrencyCodes["ALGERIAN_DINAR"] = "DZD";
    CurrencyCodes["ESTONIAN_KROON"] = "EEK";
    CurrencyCodes["EGYPTIAN_POUND"] = "EGP";
    CurrencyCodes["ERITREAN_NAKFA"] = "ERN";
    CurrencyCodes["ETHIOPIAN_BIRR"] = "ETB";
    CurrencyCodes["ETHER"] = "ETH";
    CurrencyCodes["EURO"] = "EUR";
    CurrencyCodes["FIJIAN_DOLLAR"] = "FJD";
    CurrencyCodes["FALKLAND_ISLANDS_POUND"] = "FKP";
    CurrencyCodes["BRITISH_POUND_STERLING"] = "GBP";
    CurrencyCodes["GEORGIAN_LARI"] = "GEL";
    CurrencyCodes["GUERNSEY_POUND"] = "GGP";
    CurrencyCodes["GHANAIAN_CEDI"] = "GHS";
    CurrencyCodes["GIBRALTAR_POUND"] = "GIP";
    CurrencyCodes["GAMBIAN_DALASI"] = "GMD";
    CurrencyCodes["GUINEAN_FRANC"] = "GNF";
    CurrencyCodes["GUATEMALAN_QUETZAL"] = "GTQ";
    CurrencyCodes["GUYANAESE_DOLLAR"] = "GYD";
    CurrencyCodes["HONG_KONG_DOLLAR"] = "HKD";
    CurrencyCodes["HONDURAN_LEMPIRA"] = "HNL";
    CurrencyCodes["CROATIAN_KUNA"] = "HRK";
    CurrencyCodes["HAITIAN_GOURDE"] = "HTG";
    CurrencyCodes["HUNGARIAN_FORINT"] = "HUF";
    CurrencyCodes["INDONESIAN_RUPIAH"] = "IDR";
    CurrencyCodes["ISRAELI_NEW_SHEQEL"] = "ILS";
    CurrencyCodes["MANX_POUND"] = "IMP";
    CurrencyCodes["INDIAN_RUPEE"] = "INR";
    CurrencyCodes["IRAQI_DINAR"] = "IQD";
    CurrencyCodes["IRANIAN_RIAL"] = "IRR";
    CurrencyCodes["ICELANDIC_KRONA"] = "ISK";
    CurrencyCodes["JERSEY_POUND"] = "JEP";
    CurrencyCodes["JAMAICAN_DOLLAR"] = "JMD";
    CurrencyCodes["JORDANIAN_DINAR"] = "JOD";
    CurrencyCodes["JAPANESE_YEN"] = "JPY";
    CurrencyCodes["KENYAN_SHILLING"] = "KES";
    CurrencyCodes["KYRGYSTANI_SOM"] = "KGS";
    CurrencyCodes["CAMBODIAN_RIEL"] = "KHR";
    CurrencyCodes["COMORIAN_FRANC"] = "KMF";
    CurrencyCodes["NORTH_KOREAN_WON"] = "KPW";
    CurrencyCodes["SOUTH_KOREAN_WON"] = "KRW";
    CurrencyCodes["KUWAITI_DINAR"] = "KWD";
    CurrencyCodes["CAYMAN_ISLANDS_DOLLAR"] = "KYD";
    CurrencyCodes["KAZAKHSTANI_TENGE"] = "KZT";
    CurrencyCodes["LAOTIAN_KIP"] = "LAK";
    CurrencyCodes["LEBANESE_POUND"] = "LBP";
    CurrencyCodes["SRI_LANKAN_RUPEE"] = "LKR";
    CurrencyCodes["LIBERIAN_DOLLAR"] = "LRD";
    CurrencyCodes["LESOTHO_LOTI"] = "LSL";
    CurrencyCodes["LITECOIN"] = "LTC";
    CurrencyCodes["LITHUANIAN_LITAS"] = "LTL";
    CurrencyCodes["LATVIAN_LATS"] = "LVL";
    CurrencyCodes["LIBYAN_DINAR"] = "LYD";
    CurrencyCodes["MOROCCAN_DIRHAM"] = "MAD";
    CurrencyCodes["MOLDOVAN_LEU"] = "MDL";
    CurrencyCodes["MALAGASY_ARIARY"] = "MGA";
    CurrencyCodes["MACEDONIAN_DENAR"] = "MKD";
    CurrencyCodes["MYANMA_KYAT"] = "MMK";
    CurrencyCodes["MONGOLIAN_TUGRIK"] = "MNT";
    CurrencyCodes["MACANESE_PATACA"] = "MOP";
    CurrencyCodes["MAURITANIAN_OUGUIYA"] = "MRU";
    CurrencyCodes["MAURITIAN_RUPEE"] = "MUR";
    CurrencyCodes["MALDIVIAN_RUFIYAA"] = "MVR";
    CurrencyCodes["MALAWIAN_KWACHA"] = "MWK";
    CurrencyCodes["MEXICAN_PESO"] = "MXN";
    CurrencyCodes["MALAYSIAN_RINGGIT"] = "MYR";
    CurrencyCodes["MOZAMBICAN_METICAL"] = "MZN";
    CurrencyCodes["NAMIBIAN_DOLLAR"] = "NAD";
    CurrencyCodes["NIGERIAN_NAIRA"] = "NGN";
    CurrencyCodes["NICARAGUAN_CORDOBA"] = "NIO";
    CurrencyCodes["NORWEGIAN_KRONE"] = "NOK";
    CurrencyCodes["NEPALESE_RUPEE"] = "NPR";
    CurrencyCodes["NEW_ZEALAND_DOLLAR"] = "NZD";
    CurrencyCodes["OMANI_RIAL"] = "OMR";
    CurrencyCodes["PANAMANIAN_BALBOA"] = "PAB";
    CurrencyCodes["PERUVIAN_NUEVO_SOL"] = "PEN";
    CurrencyCodes["PAPUA_NEW_GUINEAN_KINA"] = "PGK";
    CurrencyCodes["PHILIPPINE_PESO"] = "PHP";
    CurrencyCodes["PAKISTANI_RUPEE"] = "PKR";
    CurrencyCodes["POLISH_ZLOTY"] = "PLN";
    CurrencyCodes["PARAGUAYAN_GUARANI"] = "PYG";
    CurrencyCodes["QATARI_RIAL"] = "QAR";
    CurrencyCodes["ROMANIAN_LEU"] = "RON";
    CurrencyCodes["SERBIAN_DINAR"] = "RSD";
    CurrencyCodes["RUSSIAN_RUBLE"] = "RUB";
    CurrencyCodes["RWANDAN_FRANC"] = "RWF";
    CurrencyCodes["SAUDI_RIYAL"] = "SAR";
    CurrencyCodes["SOLOMON_ISLANDS_DOLLAR"] = "SBD";
    CurrencyCodes["SEYCHELLOIS_RUPEE"] = "SCR";
    CurrencyCodes["SUDANESE_POUND"] = "SDG";
    CurrencyCodes["SWEDISH_KRONA"] = "SEK";
    CurrencyCodes["SINGAPORE_DOLLAR"] = "SGD";
    CurrencyCodes["SAINT_HELENA_POUND"] = "SHP";
    CurrencyCodes["SIERRA_LEONEAN_LEONE"] = "SLL";
    CurrencyCodes["SOMALI_SHILLING"] = "SOS";
    CurrencyCodes["SURINAMESE_DOLLAR"] = "SRD";
    CurrencyCodes["SOUTH_SUDANESE_POUND"] = "SSP";
    CurrencyCodes["SAO_TOME_AND_PRINCIPE_DOBRA_PRE_2018"] = "STD";
    CurrencyCodes["SAO_TOME_AND_PRINCIPE_DOBRA"] = "STN";
    CurrencyCodes["SALVADORAN_COLON"] = "SVC";
    CurrencyCodes["SYRIAN_POUND"] = "SYP";
    CurrencyCodes["SWAZI_LILANGENI"] = "SZL";
    CurrencyCodes["THAI_BAHT"] = "THB";
    CurrencyCodes["TAJIKISTANI_SOMONI"] = "TJS";
    CurrencyCodes["TURKMENISTANI_MANAT"] = "TMT";
    CurrencyCodes["TUNISIAN_DINAR"] = "TND";
    CurrencyCodes["TONGAN_PAANGA"] = "TOP";
    CurrencyCodes["TURKISH_LIRA"] = "TRY";
    CurrencyCodes["TRINIDAD_AND_TOBAGO_DOLLAR"] = "TTD";
    CurrencyCodes["TUVALUAN_DOLLAR"] = "TVD";
    CurrencyCodes["NEW_TAIWAN_DOLLAR"] = "TWD";
    CurrencyCodes["TANZANIAN_SHILLING"] = "TZS";
    CurrencyCodes["UKRAINIAN_HRYVNIA"] = "UAH";
    CurrencyCodes["UGANDAN_SHILLING"] = "UGX";
    CurrencyCodes["UNITED_STATES_DOLLAR"] = "USD";
    CurrencyCodes["URUGUAYAN_PESO"] = "UYU";
    CurrencyCodes["UZBEKISTAN_SOM"] = "UZS";
    CurrencyCodes["VENEZUELAN_BOLIVAR_FUERTE_OLD"] = "VEF";
    CurrencyCodes["VIETNAMESE_DONG"] = "VND";
    CurrencyCodes["VANUATU_VATU"] = "VUV";
    CurrencyCodes["SAMOAN_TALA"] = "WST";
    CurrencyCodes["CFA_FRANC_BEAC"] = "XAF";
    CurrencyCodes["EAST_CARIBBEAN_DOLLAR"] = "XCD";
    CurrencyCodes["CFA_FRANC_BCEAO"] = "XOF";
    CurrencyCodes["CFP_FRANC"] = "XPF";
    CurrencyCodes["YEMENI_RIAL"] = "YER";
    CurrencyCodes["SOUTH_AFRICAN_RAND"] = "ZAR";
    CurrencyCodes["ZIMBABWE_DOLLAR"] = "ZWD";
})(CurrencyCodes || (CurrencyCodes = {}));
/**
 * Currency symbols accessible via ISO 4217 Currency codes
 *
 * @example
 * import { Currency } from '@catawiki/runtime-toolkit';
 *
 * const euroSymbol = Currency.CURRENCY_SYMBOLS[Currency.CurrencyCodes.UNITED_STATES_DOLLAR];
 *
 * expect(euroSymbol).toBe('$')
 */
export const CURRENCY_SYMBOLS = {
    [CurrencyCodes.UNITED_ARAB_EMIRATES_DIRHAM]: 'د.إ',
    [CurrencyCodes.ALBANIAN_LEK]: 'L',
    [CurrencyCodes.AFGHAN_AFGHANI]: '؋',
    [CurrencyCodes.ARMENIAN_DRAM]: '֏',
    [CurrencyCodes.NETHERLANDS_ANTILLEAN_GUILDER]: 'ƒ',
    [CurrencyCodes.ANGOLAN_KWANZA]: 'Kz',
    [CurrencyCodes.ARGENTINE_PESO]: '$',
    [CurrencyCodes.AUSTRALIAN_DOLLAR]: '$',
    [CurrencyCodes.ARUBAN_FLORIN]: 'ƒ',
    [CurrencyCodes.AZERBAIJANI_MANAT]: '₼',
    [CurrencyCodes.BOSNIA_HERZEGOVINA_CONVERTIBLE_MARK]: 'KM',
    [CurrencyCodes.BARBADIAN_DOLLAR]: '$',
    [CurrencyCodes.BANGLADESHI_TAKA]: '৳',
    [CurrencyCodes.BULGARIAN_LEV]: 'лв',
    [CurrencyCodes.BAHRAINI_DINAR]: '.د.ب',
    [CurrencyCodes.BURUNDIAN_FRANC]: 'FBu',
    [CurrencyCodes.BERMUDAN_DOLLAR]: '$',
    [CurrencyCodes.BRUNEI_DOLLAR]: '$',
    [CurrencyCodes.BOLIVIAN_BOLIVIANO]: '$b',
    [CurrencyCodes.BRAZILIAN_REAL]: 'R$',
    [CurrencyCodes.BAHAMIAN_DOLLAR]: '$',
    [CurrencyCodes.BITCOIN]: '฿',
    [CurrencyCodes.BHUTANESE_NGULTRUM]: 'Nu.',
    [CurrencyCodes.BOTSWANAN_PULA]: 'P',
    [CurrencyCodes.BELARUSIAN_RUBLE]: 'Br',
    [CurrencyCodes.BELIZE_DOLLAR]: 'BZ$',
    [CurrencyCodes.CANADIAN_DOLLAR]: '$',
    [CurrencyCodes.CONGOLESE_FRANC]: 'FC',
    [CurrencyCodes.SWISS_FRANC]: 'CHF',
    [CurrencyCodes.CHILEAN_UNIT_OF_ACCOUNT_UF]: 'UF',
    [CurrencyCodes.CHILEAN_PESO]: '$',
    [CurrencyCodes.CHINESE_YUAN]: '¥',
    [CurrencyCodes.COLOMBIAN_PESO]: '$',
    [CurrencyCodes.COSTA_RICAN_COLON]: '₡',
    [CurrencyCodes.CUBAN_CONVERTIBLE_PESO]: '$',
    [CurrencyCodes.CUBAN_PESO]: '₱',
    [CurrencyCodes.CAPE_VERDEAN_ESCUDO]: '$',
    [CurrencyCodes.CZECH_REPUBLIC_KORUNA]: 'Kč',
    [CurrencyCodes.DJIBOUTIAN_FRANC]: 'Fdj',
    [CurrencyCodes.DANISH_KRONE]: 'kr',
    [CurrencyCodes.DOMINICAN_PESO]: 'RD$',
    [CurrencyCodes.ALGERIAN_DINAR]: 'دج',
    [CurrencyCodes.ESTONIAN_KROON]: 'kr',
    [CurrencyCodes.EGYPTIAN_POUND]: '£',
    [CurrencyCodes.ERITREAN_NAKFA]: 'Nfk',
    [CurrencyCodes.ETHIOPIAN_BIRR]: 'Br',
    [CurrencyCodes.ETHER]: 'Ξ',
    [CurrencyCodes.EURO]: '€',
    [CurrencyCodes.FIJIAN_DOLLAR]: '$',
    [CurrencyCodes.FALKLAND_ISLANDS_POUND]: '£',
    [CurrencyCodes.BRITISH_POUND_STERLING]: '£',
    [CurrencyCodes.GEORGIAN_LARI]: '₾',
    [CurrencyCodes.GUERNSEY_POUND]: '£',
    [CurrencyCodes.GHANAIAN_CEDI]: 'GH₵',
    [CurrencyCodes.GIBRALTAR_POUND]: '£',
    [CurrencyCodes.GAMBIAN_DALASI]: 'D',
    [CurrencyCodes.GUINEAN_FRANC]: 'FG',
    [CurrencyCodes.GUATEMALAN_QUETZAL]: 'Q',
    [CurrencyCodes.GUYANAESE_DOLLAR]: '$',
    [CurrencyCodes.HONG_KONG_DOLLAR]: '$',
    [CurrencyCodes.HONDURAN_LEMPIRA]: 'L',
    [CurrencyCodes.CROATIAN_KUNA]: 'kn',
    [CurrencyCodes.HAITIAN_GOURDE]: 'G',
    [CurrencyCodes.HUNGARIAN_FORINT]: 'Ft',
    [CurrencyCodes.INDONESIAN_RUPIAH]: 'Rp',
    [CurrencyCodes.ISRAELI_NEW_SHEQEL]: '₪',
    [CurrencyCodes.MANX_POUND]: '£',
    [CurrencyCodes.INDIAN_RUPEE]: '₹',
    [CurrencyCodes.IRAQI_DINAR]: 'ع.د',
    [CurrencyCodes.IRANIAN_RIAL]: '﷼',
    [CurrencyCodes.ICELANDIC_KRONA]: 'kr',
    [CurrencyCodes.JERSEY_POUND]: '£',
    [CurrencyCodes.JAMAICAN_DOLLAR]: 'J$',
    [CurrencyCodes.JORDANIAN_DINAR]: 'JD',
    [CurrencyCodes.JAPANESE_YEN]: '¥',
    [CurrencyCodes.KENYAN_SHILLING]: 'KSh',
    [CurrencyCodes.KYRGYSTANI_SOM]: 'лв',
    [CurrencyCodes.CAMBODIAN_RIEL]: '៛',
    [CurrencyCodes.COMORIAN_FRANC]: 'CF',
    [CurrencyCodes.NORTH_KOREAN_WON]: '₩',
    [CurrencyCodes.SOUTH_KOREAN_WON]: '₩',
    [CurrencyCodes.KUWAITI_DINAR]: 'KD',
    [CurrencyCodes.CAYMAN_ISLANDS_DOLLAR]: '$',
    [CurrencyCodes.KAZAKHSTANI_TENGE]: 'лв',
    [CurrencyCodes.LAOTIAN_KIP]: '₭',
    [CurrencyCodes.LEBANESE_POUND]: '£',
    [CurrencyCodes.SRI_LANKAN_RUPEE]: '₨',
    [CurrencyCodes.LIBERIAN_DOLLAR]: '$',
    [CurrencyCodes.LESOTHO_LOTI]: 'M',
    [CurrencyCodes.LITECOIN]: 'Ł',
    [CurrencyCodes.LITHUANIAN_LITAS]: 'Lt',
    [CurrencyCodes.LATVIAN_LATS]: 'Ls',
    [CurrencyCodes.LIBYAN_DINAR]: 'LD',
    [CurrencyCodes.MOROCCAN_DIRHAM]: 'MAD',
    [CurrencyCodes.MOLDOVAN_LEU]: 'lei',
    [CurrencyCodes.MALAGASY_ARIARY]: 'Ar',
    [CurrencyCodes.MACEDONIAN_DENAR]: 'ден',
    [CurrencyCodes.MYANMA_KYAT]: 'K',
    [CurrencyCodes.MONGOLIAN_TUGRIK]: '₮',
    [CurrencyCodes.MACANESE_PATACA]: 'MOP$',
    [CurrencyCodes.MAURITANIAN_OUGUIYA]: 'UM',
    [CurrencyCodes.MAURITIAN_RUPEE]: '₨',
    [CurrencyCodes.MALDIVIAN_RUFIYAA]: 'Rf',
    [CurrencyCodes.MALAWIAN_KWACHA]: 'MK',
    [CurrencyCodes.MEXICAN_PESO]: '$',
    [CurrencyCodes.MALAYSIAN_RINGGIT]: 'RM',
    [CurrencyCodes.MOZAMBICAN_METICAL]: 'MT',
    [CurrencyCodes.NAMIBIAN_DOLLAR]: '$',
    [CurrencyCodes.NIGERIAN_NAIRA]: '₦',
    [CurrencyCodes.NICARAGUAN_CORDOBA]: 'C$',
    [CurrencyCodes.NORWEGIAN_KRONE]: 'kr',
    [CurrencyCodes.NEPALESE_RUPEE]: '₨',
    [CurrencyCodes.NEW_ZEALAND_DOLLAR]: '$',
    [CurrencyCodes.OMANI_RIAL]: '﷼',
    [CurrencyCodes.PANAMANIAN_BALBOA]: 'B/.',
    [CurrencyCodes.PERUVIAN_NUEVO_SOL]: 'S/.',
    [CurrencyCodes.PAPUA_NEW_GUINEAN_KINA]: 'K',
    [CurrencyCodes.PHILIPPINE_PESO]: '₱',
    [CurrencyCodes.PAKISTANI_RUPEE]: '₨',
    [CurrencyCodes.POLISH_ZLOTY]: 'zł',
    [CurrencyCodes.PARAGUAYAN_GUARANI]: 'Gs',
    [CurrencyCodes.QATARI_RIAL]: '﷼',
    [CurrencyCodes.ROMANIAN_LEU]: 'lei',
    [CurrencyCodes.SERBIAN_DINAR]: 'Дин.',
    [CurrencyCodes.RUSSIAN_RUBLE]: '₽',
    [CurrencyCodes.RWANDAN_FRANC]: 'R₣',
    [CurrencyCodes.SAUDI_RIYAL]: '﷼',
    [CurrencyCodes.SOLOMON_ISLANDS_DOLLAR]: '$',
    [CurrencyCodes.SEYCHELLOIS_RUPEE]: '₨',
    [CurrencyCodes.SUDANESE_POUND]: 'ج.س.',
    [CurrencyCodes.SWEDISH_KRONA]: 'kr',
    [CurrencyCodes.SINGAPORE_DOLLAR]: '$',
    [CurrencyCodes.SAINT_HELENA_POUND]: '£',
    [CurrencyCodes.SIERRA_LEONEAN_LEONE]: 'Le',
    [CurrencyCodes.SOMALI_SHILLING]: 'S',
    [CurrencyCodes.SURINAMESE_DOLLAR]: '$',
    [CurrencyCodes.SOUTH_SUDANESE_POUND]: '£',
    [CurrencyCodes.SAO_TOME_AND_PRINCIPE_DOBRA_PRE_2018]: 'Db',
    [CurrencyCodes.SAO_TOME_AND_PRINCIPE_DOBRA]: 'Db',
    [CurrencyCodes.SALVADORAN_COLON]: '$',
    [CurrencyCodes.SYRIAN_POUND]: '£',
    [CurrencyCodes.SWAZI_LILANGENI]: 'E',
    [CurrencyCodes.THAI_BAHT]: '฿',
    [CurrencyCodes.TAJIKISTANI_SOMONI]: 'SM',
    [CurrencyCodes.TURKMENISTANI_MANAT]: 'T',
    [CurrencyCodes.TUNISIAN_DINAR]: 'د.ت',
    [CurrencyCodes.TONGAN_PAANGA]: 'T$',
    [CurrencyCodes.TURKISH_LIRA]: '₺',
    [CurrencyCodes.TRINIDAD_AND_TOBAGO_DOLLAR]: 'TT$',
    [CurrencyCodes.TUVALUAN_DOLLAR]: '$',
    [CurrencyCodes.NEW_TAIWAN_DOLLAR]: 'NT$',
    [CurrencyCodes.TANZANIAN_SHILLING]: 'TSh',
    [CurrencyCodes.UKRAINIAN_HRYVNIA]: '₴',
    [CurrencyCodes.UGANDAN_SHILLING]: 'USh',
    [CurrencyCodes.UNITED_STATES_DOLLAR]: '$',
    [CurrencyCodes.URUGUAYAN_PESO]: '$U',
    [CurrencyCodes.UZBEKISTAN_SOM]: 'лв',
    [CurrencyCodes.VENEZUELAN_BOLIVAR_FUERTE_OLD]: 'Bs',
    [CurrencyCodes.VIETNAMESE_DONG]: '₫',
    [CurrencyCodes.VANUATU_VATU]: 'VT',
    [CurrencyCodes.SAMOAN_TALA]: 'WS$',
    [CurrencyCodes.CFA_FRANC_BEAC]: 'FCFA',
    [CurrencyCodes.EAST_CARIBBEAN_DOLLAR]: '$',
    [CurrencyCodes.CFA_FRANC_BCEAO]: 'CFA',
    [CurrencyCodes.CFP_FRANC]: '₣',
    [CurrencyCodes.YEMENI_RIAL]: '﷼',
    [CurrencyCodes.SOUTH_AFRICAN_RAND]: 'R',
    [CurrencyCodes.ZIMBABWE_DOLLAR]: 'Z$',
};
export const CurrencyCode = t.keyof(CURRENCY_SYMBOLS);
/**
 * @deprecated Use `Currency.CurrencyCodes` instead
 */
export const Currency = CurrencyCodes;
export const CurrencySymbol = t.keyof(pipe(CURRENCY_SYMBOLS, invert));
/**
 * Format number value to amount string with currency
 * @example
 *
 * import { createI18n } from '@catawiki/cata-style';
 * import { Currency } from '@catawiki/runtime-toolkit';
 *
 * const i18n = createI18n('en);
 * const amount = CurrencyCode.fromNumber(i18n, 10000, CurrencyCode.EURO);
 *
 * expect(amount).toBe('$10,000')
 *
 * @returns The formatted number with currency symbol as a string
 *
 */
export const fromNumber = (i18n, value, code, { format, precision = 2, stripInsignificantZeros } = {}) => i18n.toCurrency(value, {
    format,
    precision,
    unit: CURRENCY_SYMBOLS[code],
    strip_insignificant_zeros: stripInsignificantZeros,
});
